// CFE-110 - workaround a known issue with ui-router: https://github.com/angular-ui/ui-router/issues/2183
export function redirectTo(stateName) {
  return [
    '$injector',
    '$match',
    ($injector, $match) => {
      const $state = $injector.get('$state');
      $state.go(stateName, $match);
    },
  ];
}
